import { BigNumber } from '@0x/utils'
import { Asset } from 'app-lib/assetUtils'
import { ChainId } from 'bzx-common/src/config/appConfig'

export default class UnstakeEvent {
  public static readonly topic0: string =
    '0x2cbcd809a4c90d11f8d12c4b6d09986b255ae1e68f54f076c145fbb2185904e1'
  public readonly chainId: ChainId = 1
  public readonly user: string //indexed
  public readonly amount: BigNumber
  public readonly token: Asset
  public readonly blockNumber: BigNumber
  public readonly txHash: string
  public readonly timestamp: Date

  constructor(
    user: string,
    token: Asset,
    amount: BigNumber,
    blockNumber: BigNumber,
    txHash: string,
    timestamp: Date
  ) {
    this.user = user
    this.token = token
    this.amount = amount
    this.blockNumber = blockNumber
    this.txHash = txHash
    this.timestamp = timestamp
  }
}
